import {
  IMenuRepository,
  MenuItemEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class MenuRepository implements IMenuRepository {
  async getItems(): Promise<ResponseValueObject<MenuItemEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'layers', code: 'sisfor00507', componentName: 'layer', isPublic: true, group: 'primary', label: 'Capas', icon: 'layers', title: 'Capas del Mapa' },
      { id: 'measure', code: 'sisfor00507', componentName: 'measure', isPublic: true, group: 'primary', label: 'Medir', icon: 'ruler', title: 'Medición' },
      { id: 'graphic', code: 'sisfor00507', componentName: 'graphic', isPublic: true, group: 'primary', label: 'Gráfico', icon: 'pen', title: 'Dibujar / Anotar' },
      { id: 'analysis', code: 'sisfor00802', componentName: 'analysis', isPublic: false, group: 'tools', label: 'Análisis', icon: 'bar-chart', title: 'Análisis' },
      { id: 'print', code: 'sisfor00507', componentName: 'print', isPublic: true, group: 'tools', label: 'Impresión', icon: 'printer', title: 'Impresión' },
      { id: 'ogc', code: 'sisfor00505', componentName: 'ogc', isPublic: true, group: 'tools', label: 'Cargar', icon: 'upload', title: 'Cargar información' },
      { id: 'bookmarks', code: 'sisfor01101', componentName: 'bookmark', isPublic: false, group: 'tools', label: 'Marcadores', icon: 'bookmark', title: 'Marcadores' },
      { id: 'tour-route', code: 'sisfor00507', componentName: 'tour-route', isPublic: true, group: 'primary', label: 'Recorrido', icon: 'route', title: 'Recorrido' },
      { id: 'flight', code: 'sisfor00507', componentName: 'flight', isPublic: true, group: 'primary', label: 'Vuelo', icon: 'plane', title: 'Trazar ruta de vuelo' },
    ]);
  }

  /**
   * Catálogo de aplicaciones enlazadas desde el geoportal de presentación.
   * Datos provistos por infraestructura (fuente backend) — la presentación
   * nunca hardcodea esta lista.
   */
  async getApplications(): Promise<ResponseValueObject<MenuItemEntity[]>> {
    return new ResponseValueObject(true, [
      {
        id: 'app-observatorio',
        code: 'geoportal-observatorio',
        componentName: 'observatory',
        group: 'apps',
        isPublic: true,
        label: 'Observatorio',
        icon: 'bar-chart',
        title: 'Observatorio territorial',
        titleDetail: 'Indicadores, KPIs y series estadísticas por región y sector.',
        url: '/#/observatorio',
      },
      {
        id: 'app-alertas',
        code: 'geoportal-alertas',
        componentName: 'alerts',
        group: 'apps',
        isPublic: true,
        label: 'Alertas',
        icon: 'bell',
        title: 'Centro de alertas',
        titleDetail: 'Monitoreo de avisos meteorológicos y alertas tempranas SENAMHI.',
        url: '/#/alertas',
      },
      {
        id: 'app-descargas',
        code: 'geoportal-descargas',
        componentName: 'downloads',
        group: 'apps',
        isPublic: true,
        label: 'Descargas',
        icon: 'download',
        title: 'Centro de descargas',
        titleDetail: 'Geodatos abiertos en formatos GeoJSON, KML y Shapefile.',
        url: '/#/descargas',
      },
      {
        id: 'app-documentos',
        code: 'geoportal-documentos',
        componentName: 'documents',
        group: 'apps',
        isPublic: true,
        label: 'Documentos',
        icon: 'file-text',
        title: 'Biblioteca documental',
        titleDetail: 'Informes, fichas técnicas y normativas de interés agrario.',
        url: '/#/documentos',
      },
      {
        id: 'app-ia',
        code: 'geoportal-ia',
        componentName: 'ai',
        group: 'apps',
        isPublic: false,
        label: 'Asistente IA',
        icon: 'bot',
        title: 'Asistente inteligente',
        titleDetail: 'Consultas en lenguaje natural sobre información geoespacial.',
        url: '/#/asistente',
      },
    ]);
  }
}

